/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.DocumentType_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.DocumentType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum DocumentType_ {
   /// <summary>
   ///   Agency Agreement (AA)
   /// </summary>
   AgencyAgreement = 1,
   /// <summary>
   ///   Lease Agreement (LA)
   /// </summary>
   LeaseAgreement = 2,
   /// <summary>
   ///   Sales Contract (SC)
   /// </summary>
   SalesContract = 3,
   /// <summary>
   ///   MLS Listing Sheet (MLS)
   /// </summary>
   MlsListingSheet = 4,
   /// <summary>
   ///   Referral Fee Agreement (RFA)
   /// </summary>
   ReferralFeeAgreement = 5,
   /// <summary>
   ///   Signed Disclosures (SD)
   /// </summary>
   SignedDisclosures = 6,
   /// <summary>
   ///   Price Changes (PC)
   /// </summary>
   PriceChanges = 7,
   /// <summary>
   ///   Settlement Statement (SS)
   /// </summary>
   SettlementStatement = 8,
   /// <summary>
   ///   Commission Check/DA (CC)
   /// </summary>
   CommissionCheck = 9,
   /// <summary>
   ///   Earnest Money Check (EMC)
   /// </summary>
   EarnestMoneyCheck = 10,
   /// <summary>
   ///   Mutual Cancellation Agreement (MCA)
   /// </summary>
   MutualCancellationAgreement = 11,
   /// <summary>
   ///   Additional Files (AF)
   /// </summary>
   AdditionalFiles = 12
}

export const DocumentTypes: DocumentType[] = [
   {
      code: DocumentType_.AgencyAgreement,
      literal: 'AgencyAgreement',
      description: 'Agency Agreement',
      shortDescription: 'AA',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.LeaseAgreement,
      literal: 'LeaseAgreement',
      description: 'Lease Agreement',
      shortDescription: 'LA',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.SalesContract,
      literal: 'SalesContract',
      description: 'Sales Contract',
      shortDescription: 'SC',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.MlsListingSheet,
      literal: 'MlsListingSheet',
      description: 'MLS Listing Sheet',
      shortDescription: 'MLS',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.ReferralFeeAgreement,
      literal: 'ReferralFeeAgreement',
      description: 'Referral Fee Agreement',
      shortDescription: 'RFA',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.SignedDisclosures,
      literal: 'SignedDisclosures',
      description: 'Signed Disclosures',
      shortDescription: 'SD',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.PriceChanges,
      literal: 'PriceChanges',
      description: 'Price Changes',
      shortDescription: 'PC',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.SettlementStatement,
      literal: 'SettlementStatement',
      description: 'Settlement Statement',
      shortDescription: 'SS',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.CommissionCheck,
      literal: 'CommissionCheck',
      description: 'Commission Check/DA',
      shortDescription: 'CC',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.EarnestMoneyCheck,
      literal: 'EarnestMoneyCheck',
      description: 'Earnest Money Check',
      shortDescription: 'EMC',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.MutualCancellationAgreement,
      literal: 'MutualCancellationAgreement',
      description: 'Mutual Cancellation Agreement',
      shortDescription: 'MCA',
      listPriority: 0,

      typeName: "DocumentType"
   },
   {
      code: DocumentType_.AdditionalFiles,
      literal: 'AdditionalFiles',
      description: 'Additional Files',
      shortDescription: 'AF',
      listPriority: 0,

      typeName: "DocumentType"
   }
]

export class DocumentType implements IDomainModel {
   code: DocumentType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: DocumentType_): DocumentType {
      return DocumentTypes.find(d => d.code === code)
   }
}
